import type { TokenApiDAO } from "@/domains/tokens/types"
import { TokenStore } from "@/domains/tokens/token-store"

export class TokenApiFactory {
  static createToken(tokenDAO: TokenApiDAO): TokenStore {
    return new TokenStore(tokenDAO, "system", "token-api")
  }
}
